import { MediaContentDTO } from '@touche-lts/panel-ui/dist'
import { makeAutoObservable } from 'mobx'
// import { RootStore } from 'mobx-stores'
import { ImageUpload } from 'models/image-upload'

export class ImagesStore {
  private rootStore:any

  constructor (rootStore:any) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  //OBSERVABLES
  private squareCropImage: ImageUpload[] = null;
  private positionSquare = {x: 0, y: 0};
  private scaleSquare = 1;
  private backgroundCropImage: ImageUpload[] = null;
  private positionBackground = {x: 0, y: 0}; 
  private scaleBackground = 1;
  private cropSquareActive = false;
  private cropBackgroundActive = false;

  // ACTIONS
  public setSquareCropImage = (image: ImageUpload[]) => {
      this.squareCropImage = image;
  }

  public setBackgroundCropImage = (image: ImageUpload[]) => {
    this.backgroundCropImage = image;
  }   

  public setSqureCropEdit = (image: Partial<MediaContentDTO>) => {
    this.squareCropImage = [
        {
            file: image.url,
            link: image.url
        }
    ]
    this.positionSquare.x = image.squareX
    this.positionSquare.y = image.squareY
    this.scaleSquare = image.squareWidth
  }

  public setBackgroundCropEdit = (image: Partial<MediaContentDTO>) => {
    this.backgroundCropImage = [
        {
            file: image.url,
            link: image.url
        }
    ]
    this.positionBackground.x = image.squareX
    this.positionBackground.y = image.squareY
    this.scaleBackground = image.squareWidth
  }

  public setPositionSqure = (position): void => {
    this.positionSquare = position;
  }

  public setScaleSqure = (scale: number): void => {
    this.scaleSquare = Number(scale);
  }

  public setPositionBackground = (position): void => {
    this.positionBackground = position;
  }

  public setScaleBackground = (scale: number): void => {
    this.scaleBackground = Number(scale);
  }

  public setSquareActive = (status: boolean) => {
      this.cropSquareActive = status;
  }

  public setBackgroundActive = (status: boolean) => {
    this.cropBackgroundActive = status;
  }

  public removeSqureImage = (): void => {
    this.squareCropImage = null;
    this.positionSquare = {x: 0, y: 0};
    this.scaleSquare = 1;
    this.cropSquareActive = false;
  }

  public removeBackgroundImage = (): void => {
    this.backgroundCropImage = null;
    this.positionBackground = {x: 0, y: 0}; 
    this.scaleBackground = 1;
    this.cropBackgroundActive = false;
  }
  
  public clearStore = (): void => {
    this.squareCropImage = null;
    this.positionSquare = {x: 0, y: 0};
    this.scaleSquare = 1;
    this.backgroundCropImage = null;
    this.positionBackground = {x: 0, y: 0}; 
    this.scaleBackground = 1;
    this.cropSquareActive = false;
    this.cropBackgroundActive = false; 
  }

  // COMPUTED
  public get squareImageLink(): string {
    return !!this.squareCropImage ? this.squareCropImage[0].link : '';
  }

  public get backgroundImageLink(): string {
    return !!this.backgroundCropImage ? this.backgroundCropImage[0].link : '';
  }

  public get squareImage() {
    return this.squareCropImage
  }

  public get backgroundImage(){
    return this.backgroundCropImage
  }

  public get getPositionSquare(): {x: number, y: number} {
    return this.positionSquare
  }

  public get getPositionBackground(): {x: number, y: number} {
    return this.positionBackground
  }

  public get getScaleSquare(): number {
    return this.scaleSquare
  }

  public get getScaleBackground(): number {
    return this.scaleBackground
  }

  public get getCropSquareActive(): boolean {
    return this.cropSquareActive
  }

  public get getCropBackgroundActive(): boolean {
    return this.cropBackgroundActive
  }

  // METHODS


}
